import { createContext, useState } from "react";
import { Login } from "../../axios";
import { Constant } from "../../config/Constant";
import { LoginService } from "../../service/LoginService";
import ArchivePage from "../page/ArchivePage";
import DashboardPage from "../page/DashboardPage";
import DownloadPage from "../page/DownloadPage";
import ArchiveLogPage from "../page/ArchiveLogPage";
import LoginPage from "../page/LoginPage";
import Footer from "./Footer";
import Header from "./Header";
import Menu from "./Menu";

/**
 * 画面種別
 */
export type PageType = 'dashboard' | 'history' | 'download' | 'logseach';

/**
 * 外部から呼び出す関数一覧
 */
export type AppFunctions = {
	/** ログインユーザを返す。 */
	getLogin: () => Login | undefined,
	/** ログインユーザを設定する。 */
	setLogin: (login?: Login) => void,
	/** 表示する画面を返す。 */
	getPage: () => PageType,
	/** 表示する画面を設定する。 */
	setPage: (page: PageType) => void,
};

/** 外部から呼び出す関数用コンテキスト */
export const AppFunctionsContext = createContext<AppFunctions | undefined>(undefined);

/** トークン更新用タイマー */
let refreshTimer: NodeJS.Timer | undefined = undefined;

/**
 * 全体を表すコンポーネント
 * 
 * @returns 
 */
export default function App(): JSX.Element {

	/** ログインユーザ情報 */
	const [login, setLogin] = useState<Login | undefined>(undefined);

	/** 表示画面 */
	const [page, setPage] = useState<PageType>('dashboard');

	/**
	 * ログイン情報を設定して、トークンの更新タイマーを設定する。
	 * 
	 * @param login 
	 */
	const setLoginAndStartRefresh = (login?: Login) => {
		setLogin(login);
		setPage('dashboard');

		if (login == undefined) {
			// ログインがクリアされた場合は、更新タイマーを止める。
			if (refreshTimer != undefined) {
				clearInterval(refreshTimer);
				refreshTimer = undefined;
			}
		} else {
			// ログインが設定された場合は、更新タイマーを開始する。
			refreshTimer = setInterval(() => {
				void new LoginService(appFunctions).refresh(login.refreshToken);
			}, Constant.RefreshInterval);
		}
	}

	/** 外部から呼び出す関数一覧の実体 */
	const appFunctions: AppFunctions = {
		getLogin: () => login,
		setLogin: setLoginAndStartRefresh,
		getPage: () => page,
		setPage: setPage,
	};

	// ログインしているかで背景色を変更する。
	const body = document.getElementsByTagName('body');
	if (login == undefined) {
		body[0].style.backgroundColor = '#f0f0f0';
	} else {
		body[0].style.backgroundColor = '#fff';
	}

	/** メイン部分を描画する */
	const renderMain = () => {
		if (login == undefined) {
			// ログイン前の場合、
			return <LoginPage />;
		} else {
			// ログイン済みの場合、
			switch (page) {
				case 'dashboard':
					return <DashboardPage />
				case 'history':
					return <ArchivePage />
				case 'download':
					return <DownloadPage />
				case 'logseach':
					return <ArchiveLogPage />
			}
		}
	};

	// 描画する
	return (
		<AppFunctionsContext.Provider value={appFunctions}>
			<Header />
			<div className="container" style={{ backgroundColor: ((login == undefined) ? '#f0f0f0' : undefined) }}>
				<Menu />
				<br />
				{renderMain()}
				<hr />
				<Footer />
			</div>
		</AppFunctionsContext.Provider>
	);
}